import { axiosWrapper } from "../clients/axiosWrapper";
import image from "../fixedImages/1.png";
import image2 from "../fixedImages/2.png";
import image3 from "../fixedImages/3.png";
import image4 from "../fixedImages/4.png";
import image5 from "../fixedImages/5.png";
import image6 from "../fixedImages/6.png";
import image7 from "../fixedImages/7.png";
import image8 from "../fixedImages/8.png";
import image9 from "../fixedImages/9.png";
import image10 from "../fixedImages/10.png";
import image11 from "../fixedImages/11.png";
import image12 from "../fixedImages/12.png";
import image13 from "../fixedImages/13.png";
import image14 from "../fixedImages/14.png";
import image15 from "../fixedImages/15.png";
import image16 from "../fixedImages/16.png";
import image17 from "../fixedImages/17.png";
import image18 from "../fixedImages/18.png";
import image19 from "../fixedImages/19.png";
import image20 from "../fixedImages/20.png";
import Compressor from "compressorjs";

let baseImage;

const getImage = async (guid: string): Promise<string> => {
  const response: string = await axiosWrapper.get(`images?guid=${guid}`);
  return response;
};

const images = [
  image,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
];

const convertBase64 = (file: any): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

const uploadImage = async (e: any, setImage: Function) => {
  const image = e.target.files[0];
  await new Compressor(image, {
    quality: 0.8,
    maxWidth: 500,
    success: async (compressedResult) => {
      const baseImage = await convertBase64(compressedResult);
      setImage(baseImage);
    },
  });
};

const updateImage = async (guid: string, image: string): Promise<void> =>
  await axiosWrapper.put(`images/${guid}`, image);

export { getImage, images, uploadImage, updateImage, baseImage };
